var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose = function SvgClose(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93366 5.99935L11.1337 1.79935C11.4003 1.53268 11.4003 1.13268 11.1337 0.866016C10.867 0.599349 10.467 0.599349 10.2003 0.866016L6.00033 5.06602L1.80033 0.866016C1.53366 0.599349 1.13366 0.599349 0.866992 0.866016C0.600326 1.13268 0.600326 1.53268 0.866992 1.79935L5.06699 5.99935L0.866992 10.1993C0.600326 10.466 0.600326 10.866 0.866992 11.1327C1.00033 11.266 1.13366 11.3327 1.33366 11.3327C1.53366 11.3327 1.66699 11.266 1.80033 11.1327L6.00033 6.93268L10.2003 11.1327C10.3337 11.266 10.5337 11.3327 10.667 11.3327C10.8003 11.3327 11.0003 11.266 11.1337 11.1327C11.4003 10.866 11.4003 10.466 11.1337 10.1993L6.93366 5.99935Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "close.5505697f2aa206361a59949c2cb1c9e9.svg";